import { createModel } from '@rematch/core';
import { selectors } from './selector';
import { RootState } from '../../store';
import { DosageFormType } from '../../models/dosage-form-type';
import { getDosageFormTypes } from '../../apis/emr-data';

export interface State {
    allIds: string[];   // id: description
    byId: Dictionary<DosageFormType>;
    loading: Dictionary<boolean>;
}

export const dosageFormTypes = createModel<State>({
    state: {
        allIds: [],
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<DosageFormType>>,
            loadingKey?: string
        ): State => {
            const byId = {
                ...state.byId,
                ...processData(data)
            };
            return {
                ...state,
                allIds: Object
                    .keys(byId)
                    .sort((a, b) => byId[a]!.displayOrder - byId[b]!.displayOrder),
                byId: byId,
                ...loadingKey && {
                    loading: {
                        ...state.loading,
                        [loadingKey]: false
                    }
                }
            };
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getDosageFormTypesAsync(
            _: Undefinable<{}>,
            rootState: RootState
        ) {
            if (
                !selectors.getLoading(rootState.dosageFormTypes, 'getDosageFormTypesAsync') &&
                selectors.getDosageFormTypeIds(rootState.dosageFormTypes).length === 0
            ) {
                this.loading('getDosageFormTypesAsync', true);
                try {
                    const data = await getDosageFormTypes();
                    this.update(data, 'getDosageFormTypesAsync');
                } catch (e) {
                    window.console.log(e);
                    this.loading('getDosageFormTypesAsync', false);
                }
            }
        }
    })
});

export const processData = (data: Undefinable<MixType<DosageFormType>>): Dictionary<DosageFormType> => {
    if (data) {
        if (Array.isArray(data)) {
            return data.reduce(
                (prev, x) => {
                    prev[x.dosageFormDescription] = x;
                    return prev;
                },
                {} as Dictionary<DosageFormType>
            );
        } else {
            return {
                [data.dosageFormDescription]: data
            } as Dictionary<DosageFormType>;
        }
    } else {
        return {} as Dictionary<DosageFormType>;
    }
};
